module.exports = __webpack_public_path__ + "static/media/IMG_1-2A.1e568dba.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/IMG_1-2A.png
// module id = 652
// module chunks = 0